import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "dropdown", "item"]
  
  connect() {
    this.updateTimelineNumbers()
  }
  
  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
    this.updateTimelineNumbers()
  }
  
  remove(event) {
    event.preventDefault()
    event.stopPropagation()
    const item = event.target.closest('.timeline-item')
    
    // If there's a hidden _destroy field, mark it for destruction
    const destroyInput = item.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
      item.style.display = 'none'
    } else {
      item.remove()
    }
    
    // Close the dropdown
    this.dropdownTargets.forEach(dropdown => {
      dropdown.classList.remove('show')
    })
    
    this.updateTimelineNumbers()
  }
  
  updateTimelineNumbers() {
    const visibleItems = this.itemTargets.filter(item => item.style.display !== 'none')
    visibleItems.forEach((item, index) => {
      const numberElement = item.querySelector('.timeline-number')
      if (numberElement) {
        numberElement.textContent = index + 1
      }
      
      // Hide connector for the last item
      const connector = item.querySelector('.timeline-connector')
      if (connector) {
        if (index === visibleItems.length - 1) {
          connector.style.display = 'none'
        } else {
          connector.style.display = 'block'
        }
      }
    })
  }
  
  toggleDropdown(event) {
    event.preventDefault()
    event.stopPropagation()
    const dropdown = event.currentTarget.nextElementSibling
    
    // Close all other dropdowns
    this.dropdownTargets.forEach(d => {
      if (d !== dropdown) {
        d.classList.remove('show')
      }
    })
    
    dropdown.classList.toggle('show')
  }
  
  closeDropdown(event) {
    const dropdown = event.target.closest('.timeline-dropdown')
    if (dropdown) {
      dropdown.classList.remove('show')
    }
  }
  
  closeAllDropdowns(event) {
    // Don't close if clicking inside a dropdown or on the menu button
    if (!event.target.closest('.timeline-menu-container')) {
      this.dropdownTargets.forEach(dropdown => {
        dropdown.classList.remove('show')
      })
    }
  }
}
